module.exports = __webpack_public_path__ + "img/jo1.f4fc6550.png";